export type NavigationPolicy = 'internal' | 'checkout' | 'calendar' | 'external'

const allowedOrigins = {
  checkout: ['https://checkout.stripe.com', 'https://buy.stripe.com'],
  calendar: ['https://accounts.google.com', 'https://login.microsoftonline.com'],
}

export function safeNavigationUrl(candidate: unknown, policy: NavigationPolicy = 'internal'): string | null {
  // Reject control characters that browsers strip while parsing URL schemes.
  // eslint-disable-next-line no-control-regex
  if (typeof candidate !== 'string' || !candidate.trim() || /[\u0000-\u001f\u007f]/.test(candidate)) return null

  try {
    const url = new URL(candidate, window.location.origin)
    if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) return null
    if (url.origin === window.location.origin) return url.href
    if (policy === 'external') return url.href
    if (policy !== 'internal' && allowedOrigins[policy].includes(url.origin)) return url.href
  } catch {
    return null
  }
  return null
}

export function navigateSafely(candidate: unknown, policy: NavigationPolicy = 'internal'): boolean {
  const url = safeNavigationUrl(candidate, policy)
  if (!url) return false
  window.location.assign(url)
  return true
}

// User-selected meeting rooms and downloaded media may be on external hosts.
// Keep that behavior while rejecting executable URLs and isolating the opener.
export function openSafely(candidate: unknown): void {
  const url = safeNavigationUrl(candidate, 'external')
  if (url) window.open(url, '_blank', 'noopener,noreferrer')
}
